import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

import { Client } from 'src/providers/client/client';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { ToDos } from 'src/providers/to-dos/to-dos';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { Util } from 'src/shared/util/util';
import { TranslationPipe } from 'src/shared/pipes/translation.pipe';

@Component({
    templateUrl: 'remote-inspection.html',
    standalone: false
})

export class RemoteInspectionPage implements OnInit {

  addressId: any;
  finishPage: any;
  errorMessage: string;
  form: UntypedFormGroup;
  isRightSideContent = true;
  list: any;
  remoteInspection: boolean;
  submitted: boolean;
  typeItems: any;
  whenItems: any;
  loaded: boolean;
  hasToDos: boolean;
  
  
  boundConfirmChange = this.confirmChange.bind(this);

constructor(
    private client: Client,
    private fb: UntypedFormBuilder,
    private navCtrl: CustomNavController,
    private rightSidePanelService: RightSidePanelService,
    private storage: TidyStorage,
    private toDos: ToDos,
    private util: Util
  ) {
    this.form = this.fb.group({
      type: ['', Validators.required],
      when: ['', Validators.required]
    });
  }

  async ngOnInit() {
    this.loaded = false;
    this.rightSidePanelService.setDialogLoading(true);
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    const dialogParams = await this.storage.retrieve('dialog-params');
    this.rightSidePanelService.setDialogPageTitle('Remote Inspection');
    this.addressId = this.navCtrl.getParam('addressId') || dialogParams.addressId;
    this.finishPage = this.navCtrl.getParam('finishPage') || dialogParams.finishPage;
    this.list = this.navCtrl.getParam('list') || dialogParams.list;
    this.hasToDos = this.navCtrl.getParam('hasToDos') || dialogParams.hasToDos;
    this.typeItems = this.getTypeItems();
    this.whenItems = this.getWhenItems();
    if (this.list.before_after_photos_state !== 'inactive' && this.list.before_after_photos_state !== null) {
      this.remoteInspection = true;
      this.patchForm();
    }
    this.loaded = true;
    setTimeout(() => {
      this.rightSidePanelService.setDialogLoading(false);
    }, 1000);
  }

  getTypeItems() {
    return [
      {
        viewValue: new TranslationPipe().transform('Photos'),
        value: 'photos'
      },
      {
        viewValue: new TranslationPipe().transform('Videos'),
        value: 'videos'
      }
    ];
  }

  getWhenItems() {
    return [
      {
        viewValue: new TranslationPipe().transform('Before and after the job'),
        value: 'before_and_after'
      },
      {
        viewValue: new TranslationPipe().transform('Before the job'),
        value: 'before'
      },
      {
        viewValue: new TranslationPipe().transform('After the job'),
        value: 'after'
      }
    ];
  }

  patchForm() {
    const type = this.list.before_after_photos_state.includes('photo') ? 'photos' : 'videos';
    let when = 'before_and_after';
    if (this.list.before_after_photos_state.includes('before')) {
      when = 'before';
    } else if (this.list.before_after_photos_state.includes('after')) {
      when = 'after';
    }
    this.form.patchValue({
      type,
      when
    });
  }

  async confirmChange() {
    if (!this.hasToDos && this.remoteInspection) {
      return this.util.showError('Please add at least one checklist item to this list before turning on remote inspection.', 10000);
    }
    this.errorMessage = '';
    this.submitted = true;
    if (this.remoteInspection && !this.form.valid) {
      return;
    }
    const state = this.getState();
    try {
      await this.toDos.updateListBeforeAfterPhotos(this.list.id, state);
      await this.client.getAddresses(true);
      await this.storage.save('shouldReloadPageAfterClosingSideRail', true);
      this.rightSidePanelService.navigateTo(this.finishPage);
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message, 10000);
    }
  }

  getState() {
    if (!this.remoteInspection) {
      return 'inactive'
    } else if (this.form.value.type === 'photos' && this.form.value.when === 'before_and_after') {
      return 'photo';
    } else if (this.form.value.type === 'photos' && this.form.value.when === 'before') {
      return 'before_photo_only';
    } else if (this.form.value.type === 'photos' && this.form.value.when === 'after') {
      return 'after_photo_only';
    } else if (this.form.value.type === 'videos' && this.form.value.when === 'before_and_after') {
      return 'video';
    } else if (this.form.value.type === 'videos' && this.form.value.when === 'before') {
      return 'before_video_only';
    } else if (this.form.value.type === 'videos' && this.form.value.when === 'after') {
      return 'after_video_only';
    }
  }

}
